<div class="pill" role="status">
  <button
    type="button"
    class="pill-body"
    (click)="resume.emit()"
    [attr.aria-label]="'Resume ' + label">
    <mat-icon class="pill-icon" aria-hidden="true">expand_less</mat-icon>
    <span class="pill-label">{{ label }}</span>
    @if (dirty) {
      <span class="pill-dot" aria-label="unsaved changes"></span>
    }
  </button>

  <span class="pill-sep" aria-hidden="true"></span>

  <button type="button" class="pill-discard" (click)="discard.emit()">Discard</button>
</div>
